import { render, staticRenderFns } from "./KorisnikForma.vue?vue&type=template&id=708a0e0d&scoped=true&"
import script from "./KorisnikForma.vue?vue&type=script&lang=js&"
export * from "./KorisnikForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708a0e0d",
  null
  
)

export default component.exports